<template>
	<PageContainer size="s">
		<AmeliproCard
			card-title="Adresse e-mail manquante pour l'utilisation de PEGASE"
			class="pa-6"
		>
			<VForm ref="form">
				<p class="my-4">
					Une adresse e-mail est nécessaire pour utiliser le service Pegase,
					veuillez s'il-vous-plaît la renseigner
				</p>

				<AmeliproTextField
					id="emailUser"
					v-model="email"
					:rules="emailRules"
					required
					aria-required
					class="text-no-wrap"
					label="Adresse e-mail"
					placeholder="Votre adresse email"
					validate-on-blur
					@keyup.enter="submitEmail"
				/>

				<div class="d-flex flex-column flex-sm-row justify-sm-space-between">
					<div class="ml-auto">
						<AmeliproBtn @click="submitEmail">
							Valider
						</AmeliproBtn>
					</div>
				</div>
			</VForm>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import { required } from '@cnamts/vue-dot/src/rules/required';
	import { Refs, VForm } from '@cnamts/vue-dot/src/types';
	import { updateUtilisateurApi } from '@/services/api/api';
	import { store } from '@/store';
	import UserMixin from '@/mixins/userMixin';
	import { Meta, MetaInfo } from '@/decorators';

	const MixinsDeclaration = mixins(UserMixin);

	@Component
	export default class CreateEmail extends MixinsDeclaration {
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Renseignement adresse mail'
			};
		}

		$refs!: Refs<{
			form: VForm;
		}>;

		email = '';
		emailRules = [
			required,
			(v: string) =>
				/.+@.+\..+/.test(v) || 'Cette valeur n\'est pas une adresse e-mail valide',
			(v: string) =>
				v.length <= 320 || 'L\'adresse email ne doit pas dépasser 320 caractères'
		];

		async submitEmail(): Promise<void> {
			await this.$nextTick();
			if (this.$refs.form.validate()) {
				try {
					const response = await updateUtilisateurApi({
						email: this.email
					});
					if (response && 'data' in response) {
						// Mise à jour des informations utilisateur dans le store
						await this.$store.dispatch('authentication/storeUserInformation');
						this.$router.push('/');
						store.dispatch('notification/add', {
							type: 'success',
							message: 'Votre adresse email a bien été enregistrée'
						});
					}
				} catch (error: any) {
					store.dispatch('notification/add', {
						type: 'error',
						message: 'Une erreur est survenue lors de l\'enregistrement de l\'email'
					});
				}
			}
		}
	}
</script>
